import { FC } from 'react';

import { useItemInfoContext } from '../../ItemInfo.context';
import { StatusContent } from './StatusContent';

const toUserDetailPage = (id: string) => `/users/${id}`;

export const Status: FC = () => {
	const { components } = useItemInfoContext();
	const Link = components?.Link ?? 'a';

	return <StatusContent renderCustodyLink={(userId) => <Link href={toUserDetailPage(userId)} />} />;
};
